/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gym_Name_RequiredInputs */

const en_us2_gym_name_required = /** @type {(inputs: Gym_Name_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Give the gym a name.`)
};

const pt_br2_gym_name_required = /** @type {(inputs: Gym_Name_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dê um nome à academia.`)
};

const es_419_gym_name_required = /** @type {(inputs: Gym_Name_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ponle un nombre al gimnasio.`)
};

const pt_pt2_gym_name_required = /** @type {(inputs: Gym_Name_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dá um nome ao ginásio.`)
};

const fr_fr2_gym_name_required = /** @type {(inputs: Gym_Name_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Donne un nom à la salle.`)
};

const de_de2_gym_name_required = /** @type {(inputs: Gym_Name_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gib dem Studio einen Namen.`)
};

const it_it2_gym_name_required = /** @type {(inputs: Gym_Name_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dai un nome alla palestra.`)
};

/**
* | output |
* | --- |
* | "Give the gym a name." |
*
* @param {Gym_Name_RequiredInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const gym_name_required = /** @type {((inputs?: Gym_Name_RequiredInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gym_Name_RequiredInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_gym_name_required(inputs)
	if (locale === "es-419") return es_419_gym_name_required(inputs)
	if (locale === "pt-PT") return pt_pt2_gym_name_required(inputs)
	if (locale === "fr-FR") return fr_fr2_gym_name_required(inputs)
	if (locale === "de-DE") return de_de2_gym_name_required(inputs)
	if (locale === "it-IT") return it_it2_gym_name_required(inputs)
	return en_us2_gym_name_required(inputs)
});
export { gym_name_required as "gym.name_required" }